import { ArrowRight } from "lucide-react";
import { programCards } from "./content";
import { useLandingActions } from "./useLandingActions";

export default function ProgramsSection() {
    const { startExperience } = useLandingActions();

    return <section className="mz-section mz-section--soft" id="programs">
        <div className="mz-container">
            <div className="mz-program-intro">
                <p className="mz-section-label">Career readiness, built for the real world</p>
                <h2 className="mz-section-title">Three Pillars of Career Readiness.</h2>
                <p className="mz-section-lead">Career readiness takes more than classroom knowledge. MockZo brings together practice, practical skills, and real-world exposure to help you move confidently from campus to career.</p>
            </div>
            <div className="mz-pillar-grid" aria-label="Three pillars of career readiness">
                {programCards.map((program) => <article className="mz-program-card" key={program.title}>
                    <img src={program.image} alt={program.alt} style={{ objectPosition: program.imagePosition }} />
                    <div className="mz-program-card__body">
                        <span className="mz-program-card__number">{program.kicker}</span>
                        <h3>{program.title}</h3>
                        <strong>{program.subtitle}</strong>
                        <p>{program.description}</p>
                        <ul>{program.points.map((point) => <li key={point}>{point}</li>)}</ul>
                        <div className="mz-program-card__actions">
                            <button className="mz-button mz-button--primary mz-program-card__primary" onClick={() => program.pageUrl ? window.location.assign(program.pageUrl) : startExperience(program.experience)}>{program.action} <ArrowRight /></button>
                        </div>
                    </div>
                </article>)}
            </div>
        </div>
    </section>;
}
